<div tabindex="0" (keyup.enter)="goToModule(module)" class="h-full" fxLayout="column">
    <span id="ruler" class="ruler"></span>
    <div
        [ngStyle]="module.image && module.kind === ModuleKind.ProgramExecution && { background: 'url(' + module.image.smallUrl + ') center / cover no-repeat ' }"
        class="module-content new-tile image-module h-full"
        [class.program-execution]="module.kind === ModuleKind.ProgramExecution"
        [class.pointer]="!isTeamMembersPage || (isTeamMembersPage && module.kind === ModuleKind.ProgramExecution)"
        [class.no-image]="!module.image"
        [class.image]="module.image"
        fxLayout="column"
        (click)="goToModule(module)"
    >
        <!-- Always measurable; matches footer horizontal padding so filterTags can reserve "..." space. -->
        <div #tagsHost class="tags-width-host" aria-hidden="true"></div>
        <div
            class="content-container relative"
            fxLayout="row"
            fxLayoutAlign="space-between"
            #content
            [ngStyle]="module.image && module.kind !== ModuleKind.ProgramExecution && { background: 'url(' + module.image.smallUrl + ') top / cover no-repeat ' }"
        >
            <img style="display: none" *ngIf="module.image && module.image.unsplash" [src]="unsplashViewsBaseUrl + module.image.unsplash.unsplashId" alt="Module image" />

            <span
                class="module-status"
                *ngIf="myModuleUser?.moduleUserProgress?.status"
                [ngClass]="myModuleUser?.moduleUserProgress?.status | getStatus: moduleCompletitionStatus:'name'"
                [style.background-color]="myModuleUser?.moduleUserProgress?.status | getStatus: moduleCompletitionStatus:'color'"
            >
                {{ myModuleUser?.moduleUserProgress?.status | getStatus: moduleCompletitionStatus:'translationLabel' | translate }}
            </span>

            <div fxLayout="row" fxLayoutAlign="center" *ngIf="myModuleUser" class="badges-container">
                <span
                    class="circle gray text"
                    fxLayoutAlign="center center"
                    [style.color]="finalGrade.grade.passing ? '#464B54' : '#FF0000'"
                    *ngIf="finalGrade && finalGrade.grade && finalGrade.grade.gradingSchema && finalGrade.grade.gradingSchema.name !== 'up-gs-pass_fail_name'"
                >
                    {{ finalGrade.grade.numericValue }}
                </span>
                <span
                    class="circle gray"
                    *ngIf="myModuleUser?.moduleUserProgress?.sectionCompleteness === ModuleUserProgressStatus.Completed && module.kind !== ModuleKind.ProgramExecution"
                >
                    <mat-icon svgIcon="sections_completed_black"></mat-icon>
                </span>
                <span class="circle blue" *ngIf="(finalGrade && finalGrade.certificate) || (myModuleUser.certificates && myModuleUser.certificates.length)">
                    <mat-icon svgIcon="certificate"></mat-icon>
                </span>
            </div>
        </div>

        <div class="content">
            <div class="inner w-full">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="module-card-type" fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="module-icon" [svgIcon]="module | getModuleIcon"> </mat-icon>
                            <p>
                                {{
                                    module.kind === ModuleKind.ProgramExecution
                                        ? ('MODULE.TYPE.PROGRAM' | translate)
                                        : module.type === ModuleType.ELearning
                                        ? ('MODULE.TYPE.E-LEARNING' | translate)
                                        : module.isPrivate
                                        ? ('MODULE.TYPE.PRIVATE' | translate)
                                        : ('MODULE.TYPE.BASIC' | translate)
                                }}
                            </p>
                        </div>

                        <div class="actions-container">
                            <div class="pin-container" *ngIf="showPinModule">
                                <div class="pin">
                                    <mat-icon
                                        *ngIf="!isPinned"
                                        class="unpinned-module-icon"
                                        svgIcon="unpinned_course"
                                        (click)="onPinModule(module, true); $event.stopPropagation()"
                                    ></mat-icon>
                                    <mat-icon
                                        *ngIf="!isPinned"
                                        class="unpinned-hovered-module-icon"
                                        svgIcon="pinned_course"
                                        (click)="onPinModule(module, true); $event.stopPropagation()"
                                    ></mat-icon>
                                    <mat-icon
                                        *ngIf="isPinned"
                                        class="pinned-module-icon"
                                        svgIcon="pinned_course"
                                        (click)="onPinModule(module, false); $event.stopPropagation()"
                                    ></mat-icon>
                                </div>
                            </div>

                            <div *ngIf="!showPinModule && isTeamMembersPage && module.kind === ModuleKind.ProgramExecution">
                                <mat-icon [svgIcon]="'navigate_to'"></mat-icon>
                            </div>
                        </div>
                    </div>

                    <h3 class="mt-8 mb-4">
                        {{ module.name }}
                    </h3>

                    <div
                        class="sections-completed-progress-container mb-4"
                        fxLayout="row"
                        fxLayoutAlign="space-between center"
                        *ngIf="
                            myModuleUser?.moduleUserProgress?.status !== ModuleUserProgressStatus.NotStarted &&
                            module.type !== ModuleType.ELearning &&
                            myModuleUser.category === 'running'
                        "
                    >
                        <ng-container *ngIf="module.kind === ModuleKind.ProgramExecution; else runningModule">
                            <mat-progress-bar
                                attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                                mode="determinate"
                                [value]="myModuleUser.moduleUserProgress?.programProgress"
                            >
                            </mat-progress-bar>
                            <span class="sections-completed-progress ml-8">
                                {{ myModuleUser.moduleUserProgress?.coursesCompleted || 0 }}/{{ myModuleUser.moduleUserProgress?.coursesBooked }}
                            </span>
                        </ng-container>
                        <ng-template #runningModule>
                            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="module.hasTrackProgress" class="w-100-p">
                                <mat-progress-bar
                                    attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                                    mode="determinate"
                                    [value]="(myModuleUser.moduleUserProgress?.completedSectionsCount * 100) / module.sectionCount"
                                >
                                </mat-progress-bar>
                                <span class="sections-completed-progress ml-8">
                                    {{ myModuleUser.moduleUserProgress?.completedSectionsCount || 0 }}/{{ module.sectionCount }}
                                </span>
                            </div>
                        </ng-template>
                    </div>

                    <div class="mb-4">
                        <span class="mt-0 mb-0 block" *ngIf="module.startDate">
                            {{ 'GENERAL.LABEL.STARTING' | translate }} {{ module.startDate | date: 'mediumDate':'':selectedLanguage.dateId }}
                        </span>
                        <span class="mt-0 block" *ngIf="module.version">{{ 'GENERAL.PROPERTY.VERSION' | translate }}: {{ module.version }}</span>
                    </div>

                    <div fxLayout="column" role="list" [ngClass]="{ 'e-learning': module.type === ModuleType.ELearning }">
                        <div fxLayout="row" fxLayoutAlign="start center" role="listitem" class="min-w-0" *ngIf="module.program?.length">
                            <span class="key shrink-0">{{ 'GENERAL.LABEL.PART_OF' | translate }}:&nbsp;</span>
                            <span class="value text-truncate min-w-0" [tooltipIfTruncated]="module.program.join(', ')">
                                {{ module.program.join(', ') }}
                            </span>
                        </div>

                        <div
                            fxLayout="row"
                            role="listitem"
                            *ngIf="finalGrade && finalGrade.grade && finalGrade.grade.gradingSchema && finalGrade.grade.gradingSchema.name !== 'up-gs-pass_fail_name'"
                        >
                            <span class="key">{{ 'FINAL_GRADE.LABEL.GRADE' | translate }}:&nbsp;</span>
                            <span class="value text-truncate"> {{ finalGrade.grade.numericValue }} </span>
                        </div>

                        <div fxLayout="row" role="listitem" *ngIf="myModuleUser?.attendance">
                            <span class="key">{{ 'PAGE.MODULE_DETAILS.TAB.ATTENDANCE.TITLE' | translate }}:&nbsp;</span>
                            <span class="value text-truncate"> {{ myModuleUser.attendance.percentage || 0 }}% </span>
                        </div>

                        <div
                            fxLayout="row"
                            role="listitem"
                            *ngIf="module.digicompDuration || module.startDate || module.endDate || (module.duration && module.type === ModuleType.ELearning)"
                        >
                            <span class="key" style="white-space: nowrap">
                                {{ module.type === ModuleType.Basic ? ('GENERAL.PROPERTY.DURATION' | translate) : ('GENERAL.PROPERTY.EXPECTED_DURATION_LABEL' | translate) }}
                                :&nbsp;</span
                            >
                            <span class="value text-truncate">
                                {{
                                    module.type === ModuleType.Basic
                                        ? module.digicompDuration
                                            ? (module.digicompDuration | calculateDigicompDuration: selectedLanguage)
                                            : duration
                                        : module.rawDuration
                                        ? module.duration
                                        : '-'
                                }}
                            </span>
                        </div>
                        <div fxLayout="row" role="listitem" *ngIf="module.type === ModuleType.Basic && !module.selfPaced">
                            <span class="key">{{ 'GENERAL.PROPERTY.PERIOD' | translate }}:&nbsp;</span>
                            <span class="value text-truncate"> {{ module.startDate | date: 'shortDate' }} - {{ module.endDate | date: 'shortDate' }} </span>
                        </div>

                        <div fxLayout="row" role="listitem">
                            <span class="key" #label>{{ 'GENERAL.PROPERTY.RESPONSIBLE_MANAGERS' | translate }}:&nbsp;</span>
                            <span class="value" *ngIf="!module.responsibleManagers.length">{{ 'GENERAL.NONE' | translate }}</span>
                            <span class="value text-truncate" *ngIf="module.responsibleManagers.length" [matTooltip]="responsibleManagersString" matTooltipPosition="above">
                                {{ responsibleManagersString }}
                            </span>
                        </div>
                        <div fxLayout="row" role="listitem" *ngIf="module.type === ModuleType.Basic">
                            <span class="key">{{ 'PAGE.MODULE_DETAILS.TAB.PARTICIPANTS.TITLE' | translate }}:&nbsp;</span>
                            <span class="value">{{ module.numberOfParticipants }}</span>
                        </div>
                    </div>

                    <div class="footer">
                        <div class="tag-list-container" fxLayout="row" fxLayoutAlign="start center" *ngIf="module.tags.length">
                            <ng-container *ngIf="module.tags | filterTags: tagsHost:this:tagsLayoutKey as visibleTags">
                                <mat-chip-set class="mr-8 py-0" [class.has-more]="visibleTags.length < module.tags.length">
                                    <mat-chip
                                        *ngFor="let tag of visibleTags"
                                        (click)="filterByTag(tag); $event.stopPropagation()"
                                        class="pointer"
                                        [style.background]="tag.color"
                                        [disableRipple]="true"
                                    >
                                        {{ tag.name }}
                                    </mat-chip>
                                </mat-chip-set>
                                <ng-container *ngIf="visibleTags.length < module.tags.length">
                                    <div #more class="more-tags" (click)="$event.stopPropagation()">...</div>
                                    <app-tags-card
                                        [tags]="module.tags.slice(visibleTags.length)"
                                        [target]="more"
                                        [openAbove]="true"
                                        (clickedTag)="filterByTag($event)"
                                    ></app-tags-card>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
            </div>
        </div>

        <div class="module-card-info-container">
            <div fxLayout="row" fxLayoutAlign="flex-start center">
                <mat-icon class="module-icon mr-8 icon-18" [svgIcon]="module | getModuleIcon"> </mat-icon>

                <span class="module-type ellipsis-container" translate>
                    {{ module | getModuleKindLabel }}
                </span>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" class="module-card-info">
                <div fxLayout="column" class="w-100-p name-and-user-progress-container">
                    <h3 class="mt-8 mb-8">
                        {{ module.name }}
                    </h3>
                    <div class="status" [ngSwitch]="myModuleUser.category">
                        <div *ngSwitchCase="'upcoming'">
                            <ng-container
                                *ngIf="module.digicompDuration || module.startDate || module.endDate || (module.duration && module.type === ModuleType.ELearning); else cohortBased"
                            >
                                <div fxLayout="row">
                                    <span class="key mr-4" style="white-space: nowrap">
                                        {{
                                            module.type === ModuleType.Basic ? ('GENERAL.PROPERTY.DURATION' | translate) : ('GENERAL.PROPERTY.EXPECTED_DURATION_LABEL' | translate)
                                        }}
                                        :&nbsp;</span
                                    >

                                    <span class="value text-truncate">
                                        {{
                                            module.type === ModuleType.Basic
                                                ? module.digicompDuration
                                                    ? (module.digicompDuration | calculateDigicompDuration: selectedLanguage)
                                                    : duration
                                                : module.rawDuration
                                                ? module.duration
                                                : '-'
                                        }}
                                    </span>
                                </div>
                            </ng-container>

                            <ng-template #cohortBased>
                                <span class="mt-0 mb-4" *ngIf="module.startDate">{{ 'GENERAL.LABEL.STARTING' | translate }} {{ module.startDate | date: 'mediumDate' }} </span>
                                <span class="mt-0" *ngIf="module.version">{{ 'GENERAL.PROPERTY.VERSION' | translate }}: {{ module.version }}</span>
                            </ng-template>
                        </div>
                        <div *ngSwitchCase="'running'">
                            <div
                                class="sections-completed-progress-container"
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                                *ngIf="myModuleUser?.moduleUserProgress?.status !== ModuleUserProgressStatus.NotStarted && module.type !== ModuleType.ELearning"
                            >
                                <ng-container *ngIf="module.kind === ModuleKind.ProgramExecution; else runningModule">
                                    <mat-progress-bar
                                        attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                                        mode="determinate"
                                        [value]="myModuleUser.moduleUserProgress?.programProgress"
                                    >
                                    </mat-progress-bar>
                                    <span class="sections-completed-progress ml-8">
                                        {{ myModuleUser.moduleUserProgress?.coursesCompleted || 0 }}/{{ myModuleUser.moduleUserProgress?.coursesBooked }}
                                    </span>
                                </ng-container>
                                <ng-template #runningModule>
                                    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="module.hasTrackProgress" class="w-100-p">
                                        <mat-progress-bar
                                            attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                                            mode="determinate"
                                            [value]="(myModuleUser.moduleUserProgress?.completedSectionsCount * 100) / module.sectionCount"
                                        >
                                        </mat-progress-bar>
                                        <span class="sections-completed-progress ml-8">
                                            {{ myModuleUser.moduleUserProgress?.completedSectionsCount || 0 }}/{{ module.sectionCount }}
                                        </span>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                        <div *ngSwitchCase="'ended'">
                            <div
                                *ngIf="
                                    myModuleUser?.moduleUserProgress?.status === ModuleUserProgressStatus.NotStarted ||
                                        myModuleUser?.moduleUserProgress?.status === ModuleUserProgressStatus.InProgress;
                                    else completed
                                "
                            >
                                <span>{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.NOT_COMPLETED' | translate }}</span>
                            </div>
                            <ng-template #completed>
                                <span>{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.STATUSES.COMPLETED' | translate }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <mat-icon class="bg-icon" svgIcon="bg_illustration" *ngIf="!module.image"> </mat-icon>
    </div>
</div>
